import { isBrowser } from './env'

export type ThemePreference = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

const STORAGE_KEY = 'lunara-theme'

export function resolveSystemTheme(): ResolvedTheme {
  if (!isBrowser) return 'light'
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function resolveTheme(preference: ThemePreference): ResolvedTheme {
  return preference === 'system' ? resolveSystemTheme() : preference
}

export function getStoredPreference(): ThemePreference {
  if (!isBrowser) return 'system'
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'light' || stored === 'dark' || stored === 'system') return stored
  return 'system'
}

export function setStoredPreference(preference: ThemePreference) {
  if (!isBrowser) return
  localStorage.setItem(STORAGE_KEY, preference)
}

export function applyTheme(theme: ResolvedTheme) {
  if (!isBrowser) return
  document.documentElement.classList.toggle('dark', theme === 'dark')
}
